import styled from 'styled-components';

export const StyledDeletedLocationGroups = styled.div`
    padding: 2rem;
`;
